// 计算时间戳
export function getTime(data,type){
    var _data = data;
    //如果是13位正常，如果是10位则需要转化为毫秒
    if (String(data).length == 13) {
        _data = data
    } else {
        _data = data*1000
    }
    const time = new Date(_data);    
    const Y = time.getFullYear();
    const Mon = time.getMonth() + 1;
    const Day = time.getDate();
    const H = time.getHours();
    const Min = time.getMinutes();
    var h;
    h = H < 10 ? ('0' + H) : H;
    var m;
    m = Min < 10 ? ('0' + Min) : Min;
    const S = time.getSeconds();
    var s;
    s = S < 10 ? ('0' + S) : S;
    //自定义选择想要返回的类型
    if(type=="Y"){
        return `${Y}-${Mon}-${Day}`
    }else if(type=="H"){
        return `${h}:${Min}:${S}`
    }else if(type == 'y'){
        return `${Mon}-${Day} ${h}:${m}:${s}`
    }else{
        return `${Y}-${Mon}-${Day} ${h}:${m}:${s}`
    }
}


// WEBPACK FOOTER //
// ./src/utils/getdate.js